(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['jquery', 'underscore', 'torso/modules/Collection', './InsurancePolicyModel', 'services/insurancePolicyExtService'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    var insurancePolicyExtService = require('./../urls').insurancePolicyExtService;
    module.exports = factory(require('jquery'), require('underscore'), require('backbone-torso/modules/Collection'), require('./InsurancePolicyModel'), insurancePolicyExtService);
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function ($, _, TorsoCollection, InsurancePolicyModel, insurancePolicyExtService) {
  'use strict';

  /**
   * Receives insurance from the InsurancePolicyExtService which serves the InsurancePolicyDTO resource
   * @class InsurancePolicyCollection
   * @static
   * @extends Torso.Collection
   */
  return new (TorsoCollection.extend({
    model: InsurancePolicyModel,
    fetchHttpAction: 'POST',
    url: insurancePolicyExtService,

    /**
     * @method hasUnapprovedUpdates
     * @return {Boolean} true if any policies have pending updates, false otherwise.
     */
    hasUnapprovedUpdates: function() {
      return _.some(this.toJSON(), 'pendingInsurancePolicyDetailVecnaId');
    },

    /**
     * Sets an appointment model to sort the collection by and resorts the collection.
     * @method setAppointmentToSortBy
     * @param appointmentModelToSortBy
     */
    setAppointmentToSortBy: function(appointmentModelToSortBy) {
      if (this._appointmentModelToSortBy) {
        this.off(this._appointmentModelToSortBy);
      }
      this._appointmentModelToSortBy = appointmentModelToSortBy;
      if (this._appointmentModelToSortBy) {
        this.listenTo(this._appointmentModelToSortBy, 'change:insurancePolicies', this.sort);
      }
      this.sort();
    },

    /**
     * @method comparator
     * @override
     */
    comparator: function(firstInsurancePolicyModel, secondInsurancePolicyModel) {
      var firstInsurancePolicyVecnaId = firstInsurancePolicyModel.get('vecnaId');
      var secondInsurancePolicyVecnaId = secondInsurancePolicyModel.get('vecnaId');

      var firstEqualsSecond = firstInsurancePolicyVecnaId === secondInsurancePolicyVecnaId;

      var appointmentSecureMessageModel = this._appointmentModelToSortBy;
      if (!firstEqualsSecond && appointmentSecureMessageModel) {
        var firstAppointmentInsuranceIndex = appointmentSecureMessageModel.getAppointmentInsuranceIndex(firstInsurancePolicyVecnaId);
        var hasFirstAppointmentInsuranceInfo = firstAppointmentInsuranceIndex >= 0;
        var secondAppointmentInsuranceIndex = appointmentSecureMessageModel.getAppointmentInsuranceIndex(secondInsurancePolicyVecnaId);
        var hasSecondAppointmentInsuranceInfo = secondAppointmentInsuranceIndex >= 0;

        var firstBeforeSecond = hasFirstAppointmentInsuranceInfo && !hasSecondAppointmentInsuranceInfo;
        var firstAfterSecond = hasSecondAppointmentInsuranceInfo && !hasFirstAppointmentInsuranceInfo;

        if (hasFirstAppointmentInsuranceInfo && hasSecondAppointmentInsuranceInfo) {
          if (firstAppointmentInsuranceIndex < secondAppointmentInsuranceIndex) {
            firstBeforeSecond = true;
          }
          if (firstAppointmentInsuranceIndex > secondAppointmentInsuranceIndex) {
            firstAfterSecond = true;
          }
        }
        if (firstBeforeSecond) {
          return -1;
        }
        if (firstAfterSecond) {
          return 1;
        }
      }
      return firstInsurancePolicyVecnaId < secondInsurancePolicyVecnaId; // so that non-equal policies will always have a consistent order.
    },

    /**
     * @method parse
     * @override
     * Overrides parse to remove pendingInsuranceUpdates if the server did not resend them
     */
    parse: function(response) {
      _.each(response, function(modelAttributes) {
        if (!_.has(modelAttributes, 'pendingInsurancePolicyDetailVecnaId')) {
          modelAttributes.pendingInsurancePolicyDetailVecnaId = null;
        }
      });
      return response;
    },

    /**
     * @method fetchIdsByCriteria
     * @param criteria the criteria to use to fetch the ids
     * @returns {jQuery.Deferred} that resolves with the ids that match the criteria.
     */
    fetchIdsByCriteria: function(criteria) {
      return $.ajax({
        url: _.result(this, 'url') + '/criteria',
        contentType: 'application/json',
        type: 'POST',
        dataType: 'json',
        data: JSON.stringify(criteria)
      });
    }
  }))();
}));
